<div class="info-stocks-description">
	<div class="wrapper">
		@if (!isLoadingCompanyInfo()) {
			<div class="header box">
				<div
					class="header-left"
					[tuiSkeleton]="isLoadingAssetInfo() && isLoadingCompanyInfo()"
				>
					<app-company-logo
						[logoSrc]="assetsInfo()?.icon"
						[symbol]="liveTicker()?.ticker"
						logoWidth="30px"
						logoHeight="30px"
						[logoAlt]="liveTicker()?.ticker"
					/>
					<h5 class="logo-title">{{ companyInfo()?.symbol }}</h5>
				</div>
				<div class="header-right">
					<p class="description">{{ companyInfo()?.name }}</p>
				</div>
			</div>

			<div class="body box">
				<p class="text">
					{{ companyInfo()?.description }}
				</p>
			</div>
		}

		<div class="footer box">
			<ul class="list">
				<li class="item">
					<p
						class="title"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ 'infoStocksDescription.ceo' | translate }}
					</p>
					<p
						class="value"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ companyInfo()?.CEO ?? '-' }}
					</p>
				</li>
				<li class="item">
					<p
						class="title"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ 'infoStocksDescription.employees' | translate }}
					</p>
					<p
						class="value"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ companyInfo()?.employees | compactNumber }}
					</p>
				</li>
				<li class="item">
					<p
						class="title"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ 'infoStocksDescription.headquarters' | translate }}
					</p>
					<p
						class="value"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ fullLocation() }}
					</p>
				</li>
				<li class="item">
					<p
						class="title"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ 'infoStocksDescription.sector' | translate }}
					</p>
					<p
						class="value"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ companyInfo()?.sector || '-' }}
					</p>
				</li>
				<li class="item">
					<p
						class="title"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ 'infoStocksDescription.industry' | translate }}
					</p>
					<p
						class="value"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ companyInfo()?.industry || '-' }}
					</p>
				</li>
				<li class="item">
					<p
						class="title"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ 'infoStocksDescription.exchange' | translate }}
					</p>
					<p
						class="value"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ companyInfo()?.exchange || '-' }}
					</p>
				</li>
				<li class="item">
					<p
						class="title"
						[tuiSkeleton]="isLoadingCompanyInfo()"
					>
						{{ 'infoStocksDescription.website' | translate }}
					</p>
					<a
						target="_blank"
						[href]="companyInfo()?.website"
						class="value link"
						[tuiSkeleton]="isLoadingCompanyInfo()"
						>{{ companyInfo()?.website || '-' }}
						<tui-icon
							class="link-icon"
							icon="@tui.external-link"
						/>
					</a>
				</li>
			</ul>
		</div>
	</div>
</div>
